'use client';

import { usePathname } from 'next/navigation';

export const useGetCurrentPathFacade = () => {
  const pathname = usePathname() ?? '';
  const activePage = pathname.startsWith('/matches')
    ? 'matches'
    : pathname.startsWith('/likes')
    ? 'likes'
    : pathname.startsWith('/recommends')
    ? 'recommends'
    : pathname.startsWith('/companies')
    ? 'companies'
    : undefined;

  return {
    pathname,
    activePage,
  } as const;
};
